import { SvgWrapper } from '@ticketswap/solar/icons'

export const Google = ({ size }) => (
  <SvgWrapper a11yTitle="Google" size={size}>
    <path
      d="M11.432 1.936C7.808 3.176 4.72 5.888 3 9.32a14.733 14.733 0 0 0-1.296 3.744c-.656 3.232-.2 6.68 1.288 9.624a15.015 15.015 0 0 0 4.04 4.968 14.827 14.827 0 0 0 5.408 2.728c2.48.664 5.12.648 7.616.08 2.256-.52 4.392-1.6 6.096-3.168 1.8-1.656 3.088-3.832 3.768-6.176.744-2.552.84-5.28.376-7.904h-14v5.808h8.112a7.009 7.009 0 0 1-2.976 4.6c-.984.664-2.112 1.088-3.28 1.296-1.168.2-2.384.224-3.552-.008a8.81 8.81 0 0 1-3.312-1.432 9.2 9.2 0 0 1-3.408-4.568 9.03 9.03 0 0 1 0-5.792 9.294 9.294 0 0 1 2.16-3.512 8.826 8.826 0 0 1 4.448-2.472 8.878 8.878 0 0 1 4.368.176A8.011 8.011 0 0 1 22.064 9.2L24.8 6.464c.48-.488.984-.96 1.448-1.464-1.384-1.28-3.016-2.312-4.792-2.968-3.2-1.184-6.8-1.208-10.024-.096Z"
      fill="#fff"
    />
    <path
      d="M11.432 1.936c3.216-1.112 6.824-1.088 10.024.088a14.46 14.46 0 0 1 4.792 2.968c-.464.504-.968.976-1.448 1.464l-2.736 2.736a8.105 8.105 0 0 0-3.208-1.888 8.785 8.785 0 0 0-4.368-.176A8.892 8.892 0 0 0 10.04 9.6a9.233 9.233 0 0 0-2.16 3.512C6.256 11.848 4.632 10.592 3 9.328c1.72-3.44 4.808-6.152 8.432-7.392Z"
      fill="#EA4335"
    />
    <path
      d="M1.712 13.056a14.84 14.84 0 0 1 1.296-3.744c1.624 1.264 3.248 2.52 4.88 3.784a8.976 8.976 0 0 0 0 5.792 2007.705 2007.705 0 0 1-4.872 3.784c-1.504-2.936-1.96-6.384-1.304-9.616Z"
      fill="#FBBC05"
    />
    <path
      d="M16.296 13.208h14c.464 2.616.36 5.344-.376 7.904-.68 2.344-1.968 4.52-3.768 6.176l-4.728-3.672a7.009 7.009 0 0 0 2.976-4.6h-8.112c.008-1.936.008-3.872.008-5.808Z"
      fill="#4285F4"
    />
    <path
      d="M3 22.68c1.624-1.256 3.248-2.52 4.872-3.784a9.248 9.248 0 0 0 3.408 4.568 8.865 8.865 0 0 0 3.312 1.432c1.168.24 2.376.208 3.552.008 1.168-.208 2.296-.632 3.28-1.296l4.728 3.672c-1.704 1.576-3.84 2.648-6.096 3.168-2.496.568-5.136.584-7.616-.08a14.703 14.703 0 0 1-5.408-2.728A14.981 14.981 0 0 1 3 22.68Z"
      fill="#34A853"
    />
  </SvgWrapper>
)
